// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".He3mH{box-shadow:inset 0 0 50px 5px rgba(0,0,0,0.15);background:#fff url(https://static.toiimg.com/photo/71149155.cms) no-repeat 50%;background-size:20%}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"placeholder": "He3mH"
};
export default ___CSS_LOADER_EXPORT___;
